/*
 * @Author: tangxq 
 * @Date: 2021-07-19 09:17:26 
 * @Last Modified by: tangxq
 * @Last Modified time: 2021-07-19 18:36:39
 * @info: 添加、编辑子账号-编辑时禁止修改手机号
 */
<template>
  <iMineTemplate
    :pageTitle="pageTitle"
    :activedParentKey="activedParentKey"
    :activedKey="activedKey"
  >
    <template #rightContent>
      <div class="storeinfo">
        <div class="title" style="position:relative;">
          <span>{{accountId ? '编辑子账号' :'添加子账号'}}</span>
        </div>
        <div class="content">
          <van-form @failed="onFailed">
            <!-- 账号信息 -->
            <div class="form-panel-item">
              <p class="add-title" style="padding-top:6px;">账号信息：</p>
              <div class="insert-box">
                <!-- 账号 -->
                <div class="insert-item">
                  <van-field
                    v-model.trim="AccountPhone"
                    label="账号"
                    placeholder="请输入手机号"
                    :right-icon="getAccountIsSucIcon"
                    type="tel"
                    :error="showErrorTips"
                    :rules="[{ validator, required: true, message: ' ' }]"
                    @input="accountInput"
                    @blur="accountBlur"
                    :disabled="!!accountId"
                  />
                  <span class="error-tips" v-show="showErrorTips"
                    >* 手机号输入错误，请重新输入</span
                  >
                  <span class="error-tips" v-show="!CanRegister">
                    <span v-if="IsSalesman">【{{ AccountName }}推广经理】</span
                    >您的手机号已经添加超过5家门店，不允许再添加。
                  </span>
                </div>
                <!-- 姓名 -->
                <van-field
                  v-model.trim="AccountName"
                  required
                  label="姓名"
                  placeholder="请输入姓名"
				  maxlength="10"
                />
              </div>

              <div class="mini-tips">
                请确保手机号真实有效，登录时将会发送验证，否则无法登录
              </div>
            </div>
            <!-- 角色 -->
            <div class="form-panel-item insert-role-panel">
              <p class="add-title" style="line-height:38px;">选择角色：</p>
              <div class="role-choose-box">
                <span
                  class="role-item"
                  :class="{ active: item.checked }"
                  :key="index"
                  v-for="(item, index) in roleList"
                  @click.stop="chooseRole(item)"
                  >{{ item.RoleName || '' }}</span
                >
              </div>
            </div>
            <!-- 门店 -->
            <div class="form-panel-item">
              <p class="add-title" style="padding-top:18px;">选择门店：</p>
              <div class="store-content">
                <add-child-account-store-item
                  v-for="item in storeList"
                  :key="item.ID"
                  :storeInfo="item"
                  :maxSubCount="maxSubCount"
                />
              </div>
              <div class="mini-tips add-store-tips">
                将子账号一次性添加到多家门店中
              </div>
            </div>
            <!-- add btn -->
            <van-button
              @click.stop="addChildAccount"
              icon="plus"
              type="primary"
              native-type="submit"
              class="add-btn"
              >{{accountId ? '更新子账号' :'添加子账号'}}</van-button
            >
          </van-form>
        </div>
      </div>
    </template>
  </iMineTemplate>
</template>

<script>
import AddChildAccountStoreItem from './components/AddChildAccountStoreItem.vue'
import { BaseMixin } from '@/mixins/BaseMixin'
export default {
  mixins: [BaseMixin],
  name: 'AddChildAccount',
  components: {
    AddChildAccountStoreItem,
  },
  computed: {
    getAccountIsSucIcon() {
      const { CanRegister, showErrorTips, AccountPhone } = this
      if (
        CanRegister &&
        !showErrorTips &&
        /^1[3456789]\d{9}$/.test(AccountPhone)
      ) {
        return 'passed'
      }
      return ''
    },
  },
  data() {
    return {
      pageTitle: ['我的账户', '子账号管理', '添加子账号'],
      activedParentKey: 1,
      activedKey: 51,
      accountList: [],
      url: {
        AddChildAccount:'/api_customer/ChildAccount/AddChildAccount',
        UpdateChildAccount:'/api_customer/ChildAccount/UpdateAccount',
      },
      accountId: '', // 编辑时id
      nowUserStoreId: '', // 当前登录用户选择门店
      IsSalesman: false, // 当前手机号信息是否为推广经理
      CanRegister: true, // 当前手机号是否能继续添加为子账号
      storeList: [],
      showErrorTips: false,
      AccountPhone: '',
      AccountName: '',
      AccountRoleType: '',
      AccountStoreIds: [],
      roleList: [],
      maxSubCount: 3, // 门店最多可添加数
    }
  },
  created(){
    this.accountId = this.$route.query.accountId ?? ''
    this.maxSubCount = this.$route.query.maxSubCount ?? 3
  },
  async mounted() {
    const nowUserStoreId = this.auth.getCustomerId() || ''
    this.nowUserStoreId = nowUserStoreId
    if (this.accountId) {
      await this.getAccountDetail(this.accountId)
    }
    await this.getRoleList()
    await this.getStoreList()
  },
  methods: {
    // 获取账号详情
    async getAccountDetail(accountId) {
      try {
        const res = await this.getAction(
          '/api_customer/ChildAccount/GetAccountInfo',
          { accountId }
        )
        if (res.IsSuccess) {
          Object.assign(this.$data, res.Data)
        }
      } catch (error) {
        console.log(error)
      }
    },
    //   获取角色
    async getRoleList() {
      try {
        const res = await this.getAction(
          '/api_customer/ChildAccount/GetRoleList'
        )
        this.roleList = res.Data.map((item) => ({
          ...item,
          checked: item.RoleType === this.AccountRoleType ? true : false,
        }))
      } catch (error) {
        console.log(error)
      }
    },
    async getStoreList() {
      try {
        const { nowUserStoreId, accountId, AccountStoreIds,maxSubCount } = this
        const res = await this.getAction(
          '/api_customer/ChildAccount/GetStoreList'
        )
        // 默认选中当前门店
        if (!accountId) {
          // 新增时
          this.storeList = res.Data.map((item) => ({
            ...item,
            ChildAccountNum: (item.Id === nowUserStoreId && item.ChildAccountNum < item.MaxChildAccountNum) ? item.ChildAccountNum + 1 : item.ChildAccountNum, 
            checked: (item.Id === nowUserStoreId && item.ChildAccountNum < item.MaxChildAccountNum) ? true : false,
          }))
        } else {
          // 编辑时
          let newStoreList = res.Data
          newStoreList.forEach((element) => {
            if (AccountStoreIds.find((item) => item === element.Id)) {
              element.checked = true
            } else {
              element.checked = false
            }
          })
          this.storeList = newStoreList
        }
      } catch (error) {
        console.log(error)
      }
    },
    accountInput() {
      if (this.showErrorTips) {
        this.showErrorTips = false
      }
    },
    // 账号失去焦点时查询注册信息
    async accountBlur() {
      try {
        const { AccountPhone } = this
        if (AccountPhone && /^1[3456789]\d{9}$/.test(AccountPhone)) {
          const res = await this.getAction(
            `/api_customer/ChildAccount/GetRegisterInfoByPhone?accountPhone=${AccountPhone}`
          )
          if (res.IsSuccess) {
            const { UserName = '', IsSalesman, CanRegister } = res.Data
            this.AccountName = UserName || ''
            this.IsSalesman = IsSalesman
            this.CanRegister = CanRegister
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    validator(val) {
      const isTrue = /^1[3456789]\d{9}$/.test(val)
      if (!isTrue) {
        this.showErrorTips = true
      } else {
        this.showErrorTips = false
      }
      return isTrue
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo)
    },
    chooseRole(chooseItem) {
      const { RoleType: chooseRoleType } = chooseItem
      this.roleList = this.roleList.map((item) => ({
        ...item,
        checked: item.RoleType === chooseRoleType ? !item.checked : false,
      }))
    },
    async addChildAccount() {
      const { AccountPhone, AccountName, roleList, storeList, accountId } = this
      const AccountStoreIds = storeList
        .filter((item) => item.checked)
        .map((item) => item.Id)
      const AccountRoleType = roleList.filter((item) => item.checked)[0]
        ?.RoleType
      if (!AccountPhone) {
        this.$toast({ message: '请输入账号' })
      } else if (!AccountName) {
        this.$toast({ message: '请输入姓名' })
      } else if (!AccountStoreIds.length) {
        this.$toast({ message: '请选择门店' })
      } else if (!AccountRoleType) {
        this.$toast({ message: '请选择角色' })
      } else {
        // 校验成功
        const sendData = {
          AccountPhone,
          AccountName,
          AccountStoreIds,
          AccountRoleType,
        }
        if (!accountId) {
          // 新增
          this.$hys.openLoading();
          const res = await this.postAction(this.url.AddChildAccount, sendData)
          this.$hys.clearLoading();
          if (res.Data && res.IsSuccess) {
            this.$toast({
              message: '子账号添加成功',
              onClose: () => {
                window.history.go(-1)
              },
            })
          } else {
            this.$toast({
              message: res.Msg || '添加失败，请重试',
              duration: 3200,
            })
          }
        } else {
          // 编辑
          this.editSubmit(sendData)
        }
      }
    },
    // 编辑时提交
    async editSubmit(sendData) {
      try {
        const { accountId } = this
        this.$hys.openLoading();
        const res = await this.putAction(this.url.UpdateChildAccount, {
          ...sendData,
          Id: accountId,
        })
        this.$hys.clearLoading();
        if (res.Data && res.IsSuccess) {
          this.$toast({
            message: '子账号信息更新成功',
            onClose: () => {
              window.history.go(-1)
            },
          })
        } else {
          this.$toast({
            message: res.Msg || '更新失败，请重试',
          })
        }
      } catch (error) {}
    },
  },
}
</script>
<style lang="less" scoped>
.store-content {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 30px;
  margin-bottom: 30px;
}
.store-content::-webkit-scrollbar {
  width: 10px;
}
.store-content::-webkit-scrollbar-track {
  background: #eee;
  border-radius: 2px;
}
.store-content::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 5px;
}
.form-panel-item {
  display: flex;
}
.insert-box {
  flex: 0 0 470px;
  padding-right: 106px;
}
.add-title {
  flex: 0 0 104px;
  text-align: left;
  color: #111A34;
}
p {
  margin: 0;
}
.mini-tips {
  color: #666f83;
  font-size: 12px;
}
.content {
  padding: 30px 0;
}
.storeinfo {
  margin: 0 20px 20px 0;
  width: 940px;
  padding: 20px;
  min-height: 680px;
  font-size: 16px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border: 1px solid rgba(232, 232, 232, 1);
  // padding: 20px;
  position: relative;

  .title {
    width: 898px;
    height: 42px;
    border-bottom: 1px solid #e8e8e8;
    line-height: 22px;

    span {
      float: left;
      font-size: 18px;
      color: rgba(34, 34, 34, 1);
    }
  }

  .add-btn {
    display: block;
    width: 200px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #0f6eea;
    background-color: #0f6eea;
    color: #ffffff;
    margin: 0 auto;
  }
}

.error-tips {
  color: #ff3939;
  font-size: 12px;
}
.insert-item {
  margin-bottom: 12px;
  text-align: left;
}
/deep/ .van-cell {
  //   flex-direction: column;
  //   padding: 0 0 0.32rem;
  background: #f9fafb;
  border-radius: 4px;
  border: 1px solid #dfe1e8;
  height: 38px;
  line-height: 38px;
  padding: 0 0 0 12px;
  margin-bottom: 8px;
  transition:all .5s;
  &:hover{
    border-color: #0f6eea;
    transition:all .5s;
  }
}
/deep/ .van-cell::after {
  display: none;
}
/deep/ .van-cell--required::before {
  display: none;
}
/deep/ .van-field__label {
  //   line-height: 1.2;
  //   margin-bottom: 0.24rem;
  width: auto;
  margin-right: 0;
  display: flex;
  align-items: center;
  color: #111a34;
  font-size: 14px;
}
/deep/ .van-field__label::after {
  content: '｜';
  color: #111a34;
  font-size: 14px;
}

/deep/ .van-field__label span {
  position: relative;
  font-weight: bold;
}
/deep/ .van-cell--required .van-field__label span::after {
  //   position: absolute;
  //   color: #ee0a24;
  //   font-size: 14px;
  //   content: "*";
  //   right: -0.2rem;
  //   top: -0.03rem;
}
/deep/ input {
  padding-left: 16px;
  font-size: 14px;
  color: #111a34;
}

/deep/ .van-field__right-icon .van-icon {
  color: #3fb207;
  font-weight: bold;
  font-size: 20px;
  margin-right: 12px;
}
.role-choose-box {
  display: flex;
}
.role-item {
  width: 109px;
  height: 38px;
  text-align: center;
  line-height: 38px;
  background: #f9fafb;
  border-radius: 4px;
  border: 1px solid #dfe1e8;
  color: #111a34;
  font-size: 14px;
  font-weight: bold;
  margin-right: 12px;
  cursor: pointer;
  transition: all .5s;
  &.active {
    background: #e1eeff;
    border-color: #0f6eea;
    color: #0f6eea;
    transition: all .5s;
  }
}
.insert-role-panel {
  margin: 32px 0;
}
.add-store-tips {
  flex: 1;
  text-align: right;
}
</style>
